export const DISPONIBILITE_INDEFINI = 0;
export const NON_DISPONIBLE = 1;
export const PARTIELLEMENT_DISPONIBLE = 2;
export const DISPONIBLE = 3;

export const COULEUR_DISPO_INCONNU = '#3598DC';
export const COULEUR_DISPO_INDISPONIBLE = '#E43A45';
export const COULEUR_DISPO_PARTIELLEMENT = '#F89E37';
export const COULEUR_DISPO_OPTION = '#F8E810';
export const COULEUR_DISPO_DISPONIBLE = '#49DB70';
export const COULEUR_DISPO_INDISPONIBLE_LCNUMERIQUE = '#8e0cc5';
export const COULEUR_BLANCHE = '#FFFFFF';
export const COULEUR_SELECTION = '#c242f4';

export const CLASS_NIVEAU_DISPONIBILITE = [
  '',
  'is-nondisponible',
  'is-warning',
  'is-disponible',
];

export const ICON_COULEUR_DISPONIBILITE = [
  COULEUR_DISPO_INCONNU,
  COULEUR_DISPO_INDISPONIBLE,
  COULEUR_DISPO_PARTIELLEMENT,
  COULEUR_DISPO_DISPONIBLE,
];



// WEBPACK FOOTER //
// ./src/components/creationOpportunite/configuration/DisponibiliteConf.js